import { FetchApi } from '@backstage/core-plugin-api';
import { DeadMessage } from './FetchMqStatsService';

export class OverseerService {
  constructor(
    private readonly proxyUrl: string,
    private readonly fetchApi: FetchApi,
    private readonly env: string,
  ) {}

  moveMessages(
    queue: string,
    itemsMessages: DeadMessage[],
    typesMessages: string[],
    workspacesMessages: string[],
  ): Promise<any> {
    return this.fetchApi
      .fetch(
        `${this.proxyUrl}/overseer-${
          this.env
        }/api/v1/parking-lot/${queue}/move-messages?${this.buildMoveMessages({
          itemsMessages,
          typesMessages,
          workspacesMessages,
        })}`,
        { method: 'POST' },
      )
      .then(response => response.json());
  }

  private buildMoveMessages({
    itemsMessages,
    typesMessages,
    workspacesMessages,
  }: {
    itemsMessages: DeadMessage[];
    typesMessages: string[];
    workspacesMessages: string[];
  }) {
    const messageIds = itemsMessages
      .filter(item => item.isChecked)
      .map(item => item.properties.message_id);
    const params: string[][] = [
      ...messageIds.map(id => ['messageIds', id]),
      ...typesMessages.map(type => ['types', type]),
      ...workspacesMessages.map(workspace => ['workspaces', workspace]),
    ];

    return new URLSearchParams(params).toString();
  }
}
